<div class="entity-list">
  @if (!groupingConfig) {
    <!--    No groupingConfig => Display the entries normally, either as bulk or regular -->
    <ng-container [ngTemplateOutlet]="bulkModeActive ? entitiesBulk : entitiesRegular" [ngTemplateOutletContext]="{$implicit: entities}">
    </ng-container>
  }
  @if (groupingConfig) {
    <!--    groupingConfig provided => display each group and all entries per group, either as bulk or regular -->
    @for (g of getGroups(); track g; let gi = $index) {
      <div>
        <div class="group-label" [ngClass]="{'icon-only-on-hover': getGroupOnlyHoverFlag(g), 'intermediate-group': gi >= 1}">
          <span>{{groupingConfig.displayGroup(g)}}</span>
          @if (groupingConfig?.groupActionConfig && (groupingConfig?.groupActionConfig?.showConditional ? groupingConfig?.groupActionConfig?.showConditional(g) : true)) {
            <fa-icon (click)="handleGroupClick(g)" [icon]="getGroupIcon(g)" [pTooltip]="getGroupIconTooltip(g)"></fa-icon>
          }
        </div>
        <ng-container [ngTemplateOutlet]="bulkModeActive ? entitiesBulk : entitiesRegular" [ngTemplateOutletContext]="{$implicit: groupMappings.get(g)}">
        </ng-container>
      </div>
    }
  }
</div>
<!-- Define templates for both regular and bulk use case to prevent code duplication-->
<ng-template #entitiesRegular let-entities>
  @for (e of entities; track e) {
    <div class="entity-entry" [ngClass]="{'selected': detailView.entity && getCompareValue(detailView.entity) === getCompareValue(e), 'icon-only-on-hover': getOnlyHoverFlag(e)}" (click)="selectEntry(e)" data-testing-id="list-entry-{{getDisplayString(e)}}">
      <span>{{getDisplayString(e)}}</span>
      @if (entryActionConfig && (entryActionConfig?.showConditional ? entryActionConfig?.showConditional(e) : true)) {
        <fa-icon (click)="handleClick(e)" [icon]="getIcon(e)" [pTooltip]="getIconTooltip(e)"></fa-icon>
      }
    </div>
  }
</ng-template>
<ng-template #entitiesBulk let-entities>
  @for (e of entities; track e) {
    <div class="entity-entry bulk" (click)="toggleEntity(e)" data-testing-id="list-entry-{{getDisplayString(e)}}">
      <p-checkbox [binary]="true" [ngModel]="isEntityToggled(e)" data-testing-id="checkbox-entry-{{getDisplayString(e)}}"></p-checkbox>
      <span>{{getDisplayString(e)}}</span>
    </div>
  }
</ng-template>
